$("a.video").each(function () {

    function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    const video = $(this);

    if( video.has('.yt-thumb').length) {
        $url = 'https://img.youtube.com/vi/'+youtube_parser(video.data('mfp-src'))+'/maxresdefault.jpg';
        $image = '<img src="'+$url+'" alt="" data-object-fit="cover" loading="lazy">';
        video.find('.yt-thumb').html($image);
    }

    const thisInner = video.html();

    // Set attributes
    classAttributes = `${video.attr('class') && `class="${video.attr('class')}"`}`;
    dataAttributes = `${video.data('mfp-src') && `data-mfp-src="${video.data('mfp-src')}"`}`;
    // Apply attributes
    const buttonAttributes = `${classAttributes} ${dataAttributes}`;

    // Construct and replace with button
    video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
    
    
});